import Vue from 'vue'
import ElementUI from 'element-ui'
import '@/assets/css/element-ui.scss'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
locale.use(lang)
Vue.use(ElementUI)
